import type { HTMLAttributes } from 'react';

import { Avatar, Button, Text } from '@change/ds-core-ui';

import { useDecisionMakerResponseByLine } from './hooks/useDecisionMakerResponseByLine';

export function DecisionMakerResponseByLine(props: HTMLAttributes<HTMLDivElement>) {
	const {
		data: { author },
	} = useDecisionMakerResponseByLine();

	return (
		<div className="mb-6 mt-6 flex items-start gap-[12px] md:mb-[52px] md:mt-[52px]" {...props}>
			<Avatar size="large" src={author.photoUrl} alt="" />
			<div className="flex flex-1 flex-col items-start gap-1">
				{author.profileUrl ? (
					<Button
						variant="tertiary"
						as="a"
						href={author.profileUrl}
						className="text-ellipsis p-0 decoration-[0.5px]"
						size="large"
					>
						{author.displayName}
					</Button>
				) : (
					<Text variant="body" className="text-ellipsis decoration-[0.5px]" size="large" fontWeight="bold">
						{author.displayName}
					</Text>
				)}

				{author.title && (
					<Text variant="body" size="medium" className="text-ellipsis text-typography-weak">
						{author.title}
					</Text>
				)}
			</div>
		</div>
	);
}
